import React, { ReactNode } from 'react'

export function MessageBox({icon = 'fa fa-circle-info', className="", children}:{icon?:string, className?:string, children:ReactNode}){
    return <div className={`card shadow-sm ${className}`}>
        <div className="card-body d-flex align-items-top">
            <i className={`fa-2x ${icon} me-3 text-muted`}></i>
            <div className="flex-grow-1">
                {children}
            </div>
        </div>
    </div>
}